import React, { useRef, useState, useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import faqimage from "../assets/images/faq.svg";
import axios from "axios";
import { getAllFAQ } from "../API/FAQApi";

const Faq = () => {
    const [faqs, setFaqs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeIndex, setActiveIndex] = useState(null);
    const faqRef = useRef(null);

    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    useEffect(() => {
        const fetchFaqs = async () => {
            try {
                const res = await getAllFAQ();

                if (res) {
                    setFaqs(res.responseData);
                }
            } catch (error) {
                console.error("Error fetching FAQs:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchFaqs();
    }, []);

    if (loading) {
        return (
            <div className="min-h-full bg-gray-50">
                <Breadcrumb title="Faq" path="Faq" />
                <div className="flex justify-center items-center h-96">
                    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-theme2"></div>
                </div>
            </div>
        );
    }

    return (
        <div>
            <Breadcrumb title="Faq" path="Faq" />
            <div ref={faqRef} className="py-12">
                <h2 className="md:text-4xl text-2xl font-semibold mb-6 text-center md:px-5 px-3">
                    Frequently Asked Questions
                </h2>
                <div className="container mx-auto px-4 grid md:grid-cols-3 md:gap-10 items-center">
                    <div className="flex my-3 md:my-0 justify-center md:col-span-1">
                        <img src={faqimage} alt="FAQ illustration" className="w-full md:w-80" />
                    </div>

                    <div className="my-3 md:my-0 md:col-span-2">
                        <div className="md:space-y-3 space-y-2">
                            {faqs.length > 0 ? (
                                faqs.map((faq, index) => (
                                    <div key={faq.Id} className="border rounded-md bg-white shadow-sm">
                                        <button
                                            onClick={() => toggleFaq(index)}
                                            className="flex justify-between items-center w-full px-4 text-lg py-4 font-medium text-left"
                                        >
                                            {faq.Title}
                                            {activeIndex === index ? (
                                                <FaChevronUp className="text-contentcolor" />
                                            ) : (
                                                <FaChevronDown className="text-contentcolor" />
                                            )}
                                        </button>
                                        {activeIndex === index && (
                                            <div className="px-4 pb-4 text-gray-600 text-base">
                                                {faq.Content}
                                            </div>
                                        )}
                                    </div>
                                ))
                            ) : (
                                <p className="text-center text-gray-500">No FAQs available.</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Faq;
